export default {
  basic: () => import("/app/layouts/basic.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m)
}